import React from "react";
import styled from "styled-components";
import { useLocalStorage } from "../hooks/use-local-storage";
import Button from "../common/Button";

const Cookie = () => {
  const [show, setShow] = useLocalStorage("show-cookie", true);

  const handleClick = () => {
    setShow(false);
  };

  if (!show) return null;

  return (
    <Outer>
      <Wrapper>
        <Desc>
          Продолжая использовать сайт, Вы даете свое согласие на использование
          cookie для хранения данных.
        </Desc>
        <CustomButton onClick={handleClick} type="button" primary>
          Принять
        </CustomButton>
      </Wrapper>
    </Outer>
  );
};

const Outer = styled.div`
  display: flex;
  justify-content: center;

  position: fixed;
  bottom: 60px;
  left: 0;
  right: 0;
  z-index: 100;

  @media (max-width: 42rem) {
    left: 1rem;
    right: 1rem;
    bottom: 24px;
  }

  @media (max-width: 37.5rem) {
    z-index: 6;
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 609px;
  width: 100%;

  background: #ffffff;
  box-shadow: 0px 12px 66px rgba(0, 0, 0, 0.0908345);
  border-radius: 20px;
  padding: 22px 19px 22px 33px;

  opacity: 0;
  animation: enter 175ms ease-out 1s forwards;

  @media (max-width: 42rem) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    padding: 12px 16px;
  }

  @keyframes enter {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const Desc = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 140%;
  color: #000;
  opacity: 0.5;
  max-width: 378px;
  width: calc(100% - 18px);
  margin-right: 18px;

  @media (max-width: 42rem) {
    max-width: 100%;
    text-align: center;
    margin: 0;
    width: 100%;
  }

  @media (max-width: 32rem) {
    font-size: 12px;
  }
`;

const CustomButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 161px;
  text-transform: uppercase;
  min-height: 50px;
  font-weight: bold;
  font-size: 17px;
  line-height: 21px;
  letter-spacing: 0.3px;

  @media (max-width: 42rem) {
    margin-top: 16px;
    width: 100%;
  }

  @media (max-width: 32rem) {
    min-height: 32px;
    font-size: 12px;
    padding: 0;
  }
`;

export default Cookie;
